<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header :title="$t('menu.voucher')" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div class="common-popup-content" style="top: 4rem">
        <div class="common-voucher common-voucher02"  v-for="(item,index) in voucher" :key="item.vouchertemplate_id"  @click="receiveVoucher(item.vouchertemplate_id)">
            <div class="par">
              <p>{{ $t('voucher.order_min', [utils.currencyPrice(item.vouchertemplate_limit)]) }}</p>
              <sub class="sign">$ </sub><span>{{ utils.currencyPrice(item.vouchertemplate_price) }}</span>
              <div class="copy">
                {{ $t('voucher.expired_date') }}
                <span>{{$moment.unix(item.vouchertemplate_enddate).format('YYYY.MM.DD')}}</span>
                <!-- <span>{{ $t('voucher.exchange_point', [item.vouchertemplate_points]) }}</span>
                <span>{{ $t('voucher.exchange_now') }}</span> -->
              </div>
            </div>
            <!-- <div class="copy"></div> -->
            <!-- <i></i> -->
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { receiveVoucher } from '../../../api/homestoredetail'
export default {
  name: 'HomeStoreVoucher',
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapState({
      voucher: state => state.goodsdetail.voucher
    })
  },
  created () {

  },
  methods: {

    receiveVoucher (tid) {
      receiveVoucher(
        tid
      ).then((res) => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }

}
</script>

<style scoped>
    .common-voucher{margin:.5rem auto}
</style>
